<script setup lang="ts">
import { ref, onMounted, watch, nextTick, computed } from 'vue';

const props = withDefaults(
  defineProps<{
    text?: string;
    html?: string;
    clampLines?: 1 | 2 | 3 | 4 | 5;
    showMoreLabel?: string;
    showLessLabel?: string;
    sanitize?: boolean;
  }>(),
  {
    showMoreLabel: 'Lees meer',
    showLessLabel: 'Minder tonen',
    sanitize: false,
  },
);

const container = ref<HTMLElement | null>(null);
const expanded = ref(false);
const shouldShowLeesMeer = ref(false);

const clampClass = computed(() => {
  if (expanded.value) return '';

  switch (props.clampLines) {
    case 1:
      return 'line-clamp-1';
    case 2:
      return 'line-clamp-2';
    case 3:
      return 'line-clamp-3';
    case 4:
      return 'line-clamp-4';
    case 5:
      return 'line-clamp-5';
    default:
      return 'line-clamp-2';
  }
});

function toggle() {
  expanded.value = !expanded.value;
}

async function checkOverflow() {
  await nextTick();
  const el = container.value;
  if (!el) return;
  shouldShowLeesMeer.value = el.scrollHeight > el.clientHeight;
}

onMounted(checkOverflow);
watch(() => props.text || props.html, checkOverflow);
</script>

<template>
  <div>
    <div ref="container" class="wrap-break-word transition-all" :class="clampClass" v-if="html">
      <div v-if="sanitize" v-sanitized-html="html" class="[&>p]:mb-2"></div>
      <div v-else v-html="html"></div>
    </div>
    <div v-else ref="container" class="wrap-break-word" :class="clampClass">
      {{ text }}
    </div>

    <button
      type="button"
      v-if="shouldShowLeesMeer || expanded"
      @click="toggle"
      class="mt-1 text-xs text-black underline"
    >
      {{ expanded ? showLessLabel : showMoreLabel }}
    </button>
  </div>
</template>
